import React, { useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import FreeFeatures from "../Common/FreeFeatures";
import PremiumFeatures from "../Common/PremiumFeatures";
import { onPay } from "../../api";
import { useSelector, useDispatch } from "react-redux";
import { setStoreData } from "../../store/auth";

const promise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const PayFlowMain = ({
  selectedMethod,
  setCurrentStep,
  setSelectedFlow,
  setSelectedMethod,
}) => {
  const dispatch = useDispatch();
  const {
    title,
    subtitle,
    msrp,
    membership,
    isSupportable,
    prices,
    product_price,
    original_price,
    coupon,
    discount_type,
    multiplier,
    tmpUser,
    paypal_plan_id,
    quantity,
    showPayment,
  } = useSelector((state) => state.auth.data || {});

  const [state, setState] = useState({
    email: "",
    first_name: "",
    password: "",
    confirm_password: "",
    errorMsg: "",
    ccProcessing: false,
    // paypalProcessing: false,
    tmpCoupon: coupon,
    quantity: 1,
  });

  const [paypalProcessing, setPaypalProcessing] = useState(false);
  // 'cc' | 'paypal'
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const onUpgrade = (event) => {
    event.preventDefault();
    window.location.href = "/#prices";
  };

  const onDownload = (event) => {
    event.preventDefault();
    window.location =
      "https://downloads.wordpress.org/plugin/handl-utm-grabber.latest-stable.zip";
  };

  // const onCouponUpdate = async () => {
  //   // var field = event.target.name
  //   var res = await this.props.auth.getProductPrice(this.state.tmpCoupon);
  //   //console.log(this.state.tmpCoupon)
  //   //console.log(res)
  //   //this.setState({discount_applied: res ? res : -1})
  //   this.props.auth.setMainStates("discount_applied", res ? res : -1);
  // };

  const onPayPalPay = async (event) => {
    event.preventDefault();
    setPaypalProcessing(true);
    setSelectedMethod("paypal");
    if (isSupportable) {
      setSelectedFlow("paypalSupport");
    }
    localStorage.setItem("paidMethod", "paypal");
    localStorage.setItem("isSupportable", isSupportable);
    localStorage.setItem("isPaypalLastPay", !isSupportable);
    try {
      console.log("here");
      const response = await onPay({
        pay_id: "paypal",
        email: tmpUser.email,
        coupon: coupon,
        planId: paypal_plan_id,
        membership: membership,
        quantity: quantity,
        multiplier: multiplier ? 2 : 1,
        marketing: window.HandL.getAll(),
      });

      window.gtag("event", "begin_checkout", {
        items: [
          {
            id: "HandL002",
            name: "HandL UTM Grabber V3",
            brand: "HandL",
            category: "WordPress Plugins",
            variant: "V3",
            list_position: 2,
            quantity: quantity,
            price: `${product_price}.00`,
          },
        ],
        coupon: coupon,
        email: state.email,
      });

      window.fbq("track", "InitiateCheckout", {
        currency: "USD",
        value: `${product_price}.00`,
      });

      window.rdt("track", "AddToCart", {
        currency: "USD",
        itemCount: quantity,
        value: `${product_price}.00`,
      });

      let approveLink = response.data.links.filter(
        (link) => link.rel == "approve"
      );
      // console.log(approveLink[0].href)
      window.location = approveLink[0].href;
    } catch (err) {
      console.log(err);
      setPaypalProcessing(false);
      setState({ ...state, paypalProcessing: false });
    }
  };

  return (
    <div className="container max-w-screen-xl mx-auto md:px-12 sm:px-3 h-[calc(100vh-363.18px)] overflow-y-auto flex flex-col justify-start">
      <div className="product-desc">
        <div className="px-4 sm:px-6 lg:px-8">
          {showPayment ? (
            <div className="flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <table
                    className="min-w-full divide-y divide-gray-300"
                    id="cart"
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        ></th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Product
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Price
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Subtotal
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      <tr>
                        <td
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                          data-th="Supportable"
                        ></td>
                        <td
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                          data-th="Product"
                        >
                          <div className="row">
                            <div className="col-sm-12">
                              <h4 className="nomargin">{title}</h4>
                              <p>{subtitle}</p>
                            </div>
                          </div>
                        </td>
                        <td
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                          data-th="Price"
                        >
                          ${msrp}.00&nbsp;
                          {membership ? "/year" : ""}
                        </td>
                        <td
                          data-th="Subtotal"
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                        >
                          ${state.quantity * msrp}
                          .00&nbsp;
                          {membership ? "/year" : ""}
                        </td>
                      </tr>
                      <tr>
                        <td
                          data-th="Supportable"
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                        >
                          <input
                            type="checkbox"
                            checked={isSupportable || false}
                            onChange={(e) => {
                              if (selectedMethod === "paypal") {
                                setSelectedFlow(
                                  isSupportable ? "other" : "paypalSupport"
                                );
                              }
                              dispatch(
                                setStoreData({
                                  data: {
                                    isSupportable: !isSupportable,
                                  },
                                })
                              );
                            }}
                          />
                        </td>
                        <td
                          data-th="Product"
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                        >
                          <div className="row">
                            <div className="col-sm-12">
                              <h4 className="nomargin">
                                {prices.support.title}
                              </h4>
                              <p>{prices.support.subtitle}</p>
                            </div>
                          </div>
                        </td>
                        <td
                          data-th="Price"
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                        >
                          ${prices.support.msrp}
                          .00&nbsp;
                          {prices.support.membership ? "/year" : ""}
                        </td>
                        <td
                          data-th="Subtotal"
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                        >
                          ${prices.support.msrp}
                          .00 {prices.support.membership ? "/year" : ""}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="3"
                          className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
                        ></td>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                          <strong>
                            Total $
                            {state.quantity * product_price +
                              (isSupportable ? prices.support.msrp : 0)}
                            .00&nbsp;
                            {membership ? "/year" : ""}
                          </strong>
                        </td>
                      </tr>
                      {original_price - product_price > 0 && (
                        <tr>
                          <td
                            colSpan="3"
                            data-th="Product"
                            className="text-success"
                          >
                            {coupon != ""
                              ? `Discount ${
                                  discount_type == "once"
                                    ? " for the first year - "
                                    : " for every year - "
                                }` + coupon
                              : `Discount ${
                                  discount_type == "once"
                                    ? " for the first year"
                                    : " for every year"
                                }`}
                          </td>
                          <td className="text-center text-success ">
                            -$
                            {state.quantity * (original_price - product_price)}
                            .00
                          </td>
                        </tr>
                      )}
                      {multiplier && (
                        <tr>
                          <td
                            colSpan="3"
                            data-th="Product"
                            className="text-success"
                          >
                            <b>🎁 Bonus: Double the licenses</b>
                          </td>
                          <td className="text-center text-success">FREE</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="flex flex-row gap-6 justify-end items-center">
                <div className="pay-area row m0">
                  <button
                    className={`btn btn-rounded btn-block handlPayButton ${
                      selectedPaymentMethod === "cc" ? "selected" : ""
                    }`}
                    onClick={() => setSelectedPaymentMethod("cc")}
                  >
                    <i className="fa fa-credit-card"></i>&nbsp; Credit Card
                  </button>
                </div>
                <div className="pay-area row m0">
                  <button
                    className={`btn btn-rounded btn-block handlPayButton ${
                      paypalProcessing ? "selected" : ""
                    }`}
                    onClick={(e) => {
                      setSelectedPaymentMethod("paypal");
                      onPayPalPay(e);
                    }}
                  >
                    {paypalProcessing ? (
                      <>
                        <i className="fa fa-spin fa-spinner"></i> Processing...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paypal"></i>&nbsp; Pay With Paypal
                      </>
                    )}
                  </button>
                </div>
              </div>
              {selectedPaymentMethod === "cc" && (
                <div className="billing-info slide-down">
                  <Elements stripe={promise}>
                    <CheckoutForm
                      setCurrentStep={setCurrentStep}
                      setSelectedMethod={setSelectedMethod}
                    />
                  </Elements>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center" id="js-download-info">
              <div className="row offer-box">
                <div className="col-md-6">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">UTM Grabber V2 (FREE)</h3>
                    </div>
                    <div className="panel-body greencheck nope text-left">
                      <FreeFeatures />
                    </div>
                    <div className="panel-footer">
                      <a
                        className="btn btn-sm btn-primary"
                        onClick={onDownload}
                      >
                        Download
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="panel panel-success">
                    <div className="panel-heading">
                      <h3 className="panel-title">UTM Grabber V3</h3>
                    </div>
                    <div className="panel-body greencheck text-left">
                      <PremiumFeatures />
                    </div>
                    <div className="panel-footer">
                      <a
                        href=""
                        className="btn btn-sm btn-success"
                        onClick={onUpgrade}
                      >
                        Upgrade Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PayFlowMain;
